import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import LeadScoringSettings from './LeadScoringSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lead-scoring'),
      component: SettingsContent,
      props: () => ({
        headerTitle: 'Lead Scoring',
        icon: 'flash',
        showNewButton: false,
        showBackButton: false,
      }),
      children: [
        {
          path: '',
          name: 'lead_scoring_settings',
          component: LeadScoringSettings,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
